import { Injectable } from '@angular/core';
import { EvkHttpService, EvkUpdateServiceBase } from '@evomatik/evk-common';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
    providedIn: 'root'
})
export class EvkDiligenciaFinalizarEnviarService extends EvkUpdateServiceBase<any> {

    constructor(h: EvkHttpService) {
        super(h);
    }

    public get api(): string {
        return '/seaged-diligencias-service/diligencia/v2/finalizar-enviar';
    }

    evkOnBeforeEdit(data: any): Observable<any> {
        return new Observable<any>(subscriber => subscriber.next(data));
    }

    evkOnDoneEdit(response: any): void {
    }

    evkOnErrorEdit(error: any): void {
    }
}
